import React, { useState, useContext } from 'react'
import { truncate } from 'lodash'
import styled from 'styled-components'
import { Badge } from 'react-bootstrap'
import { I18nContext } from 'i18n'

const TruncatedText = ({ children, onClick, cssClass, ...rest }) => {
  const truncateLength = 100
  const canTruncate = children.length > truncateLength
  const [truncated, setTruncated] = useState(false)
  const { translate } = useContext(I18nContext)

  const handleClick = () => {
    setTruncated(!truncated)
    if (onClick) onClick(cssClass);
  }

  return (
    <div {...rest}>
      <Text>
        {!truncated ? truncate(children, { length: truncateLength }) : children}
        {canTruncate && (
          <More variant="primary" onClick={handleClick}>
            {truncated ? translate('program_less') : translate('program_more') }
          </More>
        )}
      </Text>
    </div>
  )
}

const More = styled(Badge)`
  background-color: ${({ theme }) => theme.palette.primary[2]};
  cursor: pointer;
  margin-left: 0.5rem;
  float: right;
`

const Text = styled.div`
  white-space: pre-wrap;
`

export default TruncatedText
